module.exports = __webpack_public_path__ + "static/media/bloom-logo.0b579db4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/companies/bloom-logo.png
 ** module id = 425
 ** module chunks = 0
 **/